import {enqueueSnackbar} from "notistack";
import './styles.css';

export default function successToast(message) {
    return enqueueSnackbar(message, {
        variant: 'success',
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
        className: 'snackbar-custom',
    })
}